const FAMILIES = ['refrescante', 'fuerte', 'dulce', 'clasico', 'amargo'];

const FAMILY_ALIASES = {
  refrescante: 'refrescante',
  fresco: 'refrescante',
  frozen: 'refrescante',
  fuerte: 'fuerte',
  strong: 'fuerte',
  'spirit-forward': 'fuerte',
  dulce: 'dulce',
  sweet: 'dulce',
  clasico: 'clasico',
  'clásico': 'clasico',
  classic: 'clasico',
  amargo: 'amargo',
  bitter: 'amargo',
};

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const hashToRange = (seed, min, max) => {
  const text = String(seed ?? '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  }
  const span = max - min;
  return min + (hash % (span + 1));
};

export const normalizeFamily = (raw) => {
  if (!raw) return null;
  const key = String(raw)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();
  return FAMILY_ALIASES[key] || null;
};

export const getFamily = (item) => {
  const fromApi = normalizeFamily(item?.family || item?.cocktailFamily);
  if (fromApi && FAMILIES.includes(fromApi)) return fromApi;
  return 'clasico';
};

export const getSweetness = (item) => {
  const raw = item?.sweetness ?? item?.dulzor;
  const has = raw !== undefined && raw !== null && raw !== '';
  return has ? clamp(Number(raw), 0, 100) : hashToRange(`${item?.id}-sweetness`, 15, 85);
};

export const getStrength = (item) => {
  const raw = item?.strength ?? item?.fuerza;
  const has = raw !== undefined && raw !== null && raw !== '';
  return has ? clamp(Number(raw), 0, 100) : hashToRange(`${item?.id}-strength`, 15, 85);
};

export const FAMILY_FILTERS = [
  { id: 'all', label: 'Todos' },
  { id: 'refrescante', label: 'Refrescante' },
  { id: 'fuerte', label: 'Fuerte' },
  { id: 'dulce', label: 'Dulce' },
  { id: 'clasico', label: 'Clásico' },
  { id: 'amargo', label: 'Amargo' },
];
